function Hotspot(source) {
	this.id = null;
	this.name = null;
	this.scene = null;
	this.url = null;
	this.normalizedUrl = null;
	this.posterUrl = null;
	this.normalizedPosterUrl = null;
	this.x = null;
	this.y = null;
	this.z = null;
	this.dx = null;
	this.dy = null;
	this.distance = null;
	this.location = null;
	this.on_click = null;

	if (source) {
		Object.assign(this, source);
	}
}

Hotspot.LOCATIONS = {
	in_focus: 'in_focus',
	on_edge: 'on_edge',
	off_screen: 'off_screen'
};

export default Hotspot;
